import { Component, Inject, Input, OnInit, HostListener } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/core/services/account.service';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { ADPResourceService, CustomFormControl, ListItem } from 'digital-core';

@Component({
  selector: 'pgh-deductible-service-fees',
  templateUrl: './deductible-service-fees.component.html',
  styleUrls: ['./deductible-service-fees.component.scss']
})
export class DeductibleServiceFeesComponent implements OnInit {

  isDesktopView:boolean = false;
  productCategories: ListItem[] = [];
  productCategory = '';
  showEntertainmentServiceFees:boolean = true;
  showHomeServiceFees:boolean = false;
  showHomeOfficeServiceFees:boolean = false;
  showPersonalServiceFees:boolean = false;

  public serviceFeesForm = new FormGroup({
    SelectProductCategories: new CustomFormControl(this.productCategory)
  });

  constructor(
    private resourceService: ADPResourceService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDesktopView = window.innerWidth >= 768;
  }

  ngOnInit() {

    this.isDesktopView = this.isUserUsingDesktop();
    this.getProductCategories();

  }

  getProductCategories() {

    let prodCategories = this.resourceService.getListItemResource("Global_Deductible_Service_Fees_Product_Categories");

    prodCategories.subscribe((data) => {
            this.productCategories = data;
            this.serviceFeesForm.get('SelectProductCategories').setValue(data[0].Value);
        });
  }

  getResource(title: string) {
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  public updateServiceFees() {
    const selectedProductCategory: string = this.serviceFeesForm.controls['SelectProductCategories'].value;

    this.clearServiceFees();

    if(selectedProductCategory === this.productCategories[0].Value){
      this.showEntertainmentServiceFees = true;
    }
    else if(selectedProductCategory === this.productCategories[1].Value){
      this.showHomeServiceFees = true;
    }
    else if(selectedProductCategory === this.productCategories[2].Value){
      this.showHomeOfficeServiceFees = true;
    }
    else if(selectedProductCategory === this.productCategories[3].Value){
      this.showPersonalServiceFees = true;
    }
  }

  public clearServiceFees(){
    this.showEntertainmentServiceFees = false;
    this.showHomeServiceFees = false;
    this.showHomeOfficeServiceFees = false;
    this.showPersonalServiceFees = false;
  }

  isUserUsingDesktop() : boolean {

    // User agent string method
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Screen resolution method
    if (!isMobile) {
        let screenWidth = window.screen.width;
        let screenHeight = window.screen.height;
        isMobile = (screenWidth < 768 || screenHeight < 768);
    }

    // Touch events method
    if (!isMobile) {
        isMobile = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
    }

    // CSS media queries method
    if (!isMobile) {
        let bodyElement = document.getElementsByTagName('body')[0];
        isMobile = window.getComputedStyle(bodyElement).getPropertyValue('content').indexOf('mobile') !== -1;
    }

    return !isMobile

}

}
